import { MyAppList } from '../../../components/service/accounts/me/apps';
export const MyAppPageView = () => {
  return <MyAppList data-sentry-element="MyAppList" data-sentry-component="MyAppPageView" data-sentry-source-file="my-app.tsx" />;
};